import { type FC } from "react";

export type TooltipValue = string | number | Array<string | number>;
export type TooltipPayloadItem = {
  name?: string | number;
  value?: TooltipValue;
};

export const normalizeTooltipValue = (value: TooltipValue | undefined) => {
  if (Array.isArray(value)) {
    return value.join(", ");
  }

  return value ?? "";
};

export const OrganicChartTooltip: FC<{
  active?: boolean;
  label?: string | number;
  labelTitle: string;
  payload?: TooltipPayloadItem[];
  valueFormatter?: (_value: TooltipValue | undefined, _name: string) => string;
  accentColor?: string;
  seriesLabelForDataKey?: (_dataKey: string) => string;
}> = ({
  active,
  label,
  labelTitle,
  payload,
  valueFormatter = value => String(normalizeTooltipValue(value)),
  accentColor = "#2b74e4",
  seriesLabelForDataKey,
}) => {
  if (!active || !payload?.length) {
    return null;
  }

  return (
    <div className="organic-tooltip organic-tooltip--kpi">
      <div className="organic-tooltip__bar" style={{ background: accentColor }} />
      <div className="organic-tooltip__content">
        <div className="organic-tooltip__meta-line">
          <span className="organic-tooltip__meta-label">{labelTitle}:</span>
          <strong className="organic-tooltip__meta-value">{String(label ?? "")}</strong>
        </div>
        {payload.map(entry => {
          const seriesKey = String(entry.name ?? "");
          const seriesLabel = seriesLabelForDataKey
            ? seriesLabelForDataKey(seriesKey)
            : seriesKey || "Value";
          return (
            <div
              className="organic-tooltip__meta-line"
              key={`${seriesKey}-${String(entry.value)}`}
            >
              <span className="organic-tooltip__meta-label">{seriesLabel}:</span>
              <strong className="organic-tooltip__meta-value">
                {valueFormatter(entry.value, seriesKey)}
              </strong>
            </div>
          );
        })}
      </div>
    </div>
  );
};
